/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {Tr} from '../../../_metronic/i18n/Tr'

interface AddTourPackageProps {
  tourpackageId: string // Assuming tourpackageId is of type string, adjust as needed
}
const AddTourPackageHeader: React.FC<AddTourPackageProps> = ({tourpackageId}) => {
  let t = Tr()
  const location = useLocation()
  const editTourpackageId = (location.state as any)?.tourpackageId || ''
  const {menuId} = useMenuIdPermissions()

  const [tourPackageDetails, setTourPackageDetails] = useState([])
  // hotel Details api call
  const tourpackageDetailsApiCall = async () => {
    if (tourpackageId != '') {
      var param: any = {
        tourpackageId: tourpackageId,
      }
    } else if (editTourpackageId != '') {
      var param: any = {
        tourpackageId: editTourpackageId,
      }
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)

    if (response.status == '200') {
      setTourPackageDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editTourpackageId != '') {
      tourpackageDetailsApiCall()
    }
  }, [])

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['basicInfo'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagebasicinfo/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addtourpackagebasicinfo/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Basic Info')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagebasicinfo/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Basic Info')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['location'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['location']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagelocation/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['location']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addtourpackagelocation/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Location')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['location']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagelocation/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['location']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Location')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['toursDetail'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['toursDetail']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewtours/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['toursDetail']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../viewtours/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Tours')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['toursDetail']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewtours/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['toursDetail']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Tours')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['photos'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['photos']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagephotos/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['photos']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addtourpackagephotos/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Photos')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['photos']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagephotos/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['photos']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Photos')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['policies'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['policies']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagepolicies/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['policies']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addtourpackagepolicies/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Policies')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['policies']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagepolicies/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['policies']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Policies')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {tourPackageDetails &&
                tourPackageDetails.length > 0 &&
                tourPackageDetails[0]['completedSteps'] &&
                tourPackageDetails[0]['completedSteps']['financeAndLegal'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagefinance/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addtourpackagefinance/', {menuId:menuId})}
                    state={{tourpackageId: editTourpackageId}}
                  >
                    {t('Finance & Legal')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      tourPackageDetails &&
                      tourPackageDetails.length > 0 &&
                      tourPackageDetails[0]['completedSteps'] &&
                      tourPackageDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addtourpackagefinance/'
                        ? `${
                            tourPackageDetails &&
                            tourPackageDetails.length > 0 &&
                            tourPackageDetails[0]['completedSteps'] &&
                            tourPackageDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Finance & Legal')}
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export {AddTourPackageHeader}
